import React from 'react';
import cn from 'classnames';
import { isNil } from 'lodash';

import CurrencySign from 'components/price/CurrencySign.component';
import { withTheme } from 'providers/Theme.provider';
import isNegativeNumber from 'utils/predicates/number/isNegativeNumber.util';
import isFullString from 'utils/predicates/string/isFullString.util';
import hasReactChildren from 'utils/react/hasReactChildren.util';

import CN from './Cell.module.scss';

const Cell = ({ value, children, isDarkMode, isLightMode, isBrightMode, selected, width }) => (
  <div
    data-bem="Cell"
    className={cn({
      [CN.component]: true,
      [CN[`${width}Width`]]: width,
      [CN.dark]: isDarkMode,
      'dark-class': isDarkMode,
      'light-class': isLightMode,
      'bright-class': isBrightMode,
    })}
  >
    {hasReactChildren(children)
      ? children
      : !isNil(value) && (
          <span
            className={cn({
              [CN.value]: true,
              [CN.danger]: isNegativeNumber(value),
              [CN.selected]: selected,
            })}
          >
            {isFullString(value) ? value : <CurrencySign minus="first" value={value} />}
          </span>
        )}
  </div>
);

const CellHoc = withTheme({ hasBright: true })(Cell);

export default CellHoc;
